import { render, staticRenderFns } from "./Inactive.vue?vue&type=template&id=e1878972&scoped=true"
import script from "./Inactive.vue?vue&type=script&lang=js"
export * from "./Inactive.vue?vue&type=script&lang=js"
import style0 from "./Inactive.vue?vue&type=style&index=0&id=e1878972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1878972",
  null
  
)

export default component.exports